import type { TranslationMap } from '../i18n';

export const es: TranslationMap = {
  // Auth - Common
  'auth.email': 'Correo electrónico',
  'auth.password': 'Contraseña',
  'auth.firstName': 'Nombre',
  'auth.lastName': 'Apellido',
  'auth.back': '← Volver',
  'auth.acceptTerms': 'Acepto los',
  'auth.termsAndConditions': 'Términos y condiciones',
  'auth.verificationRequired': 'Verificación requerida',
  'auth.verificationLinkSent': 'Haz clic en el enlace de verificación en tu bandeja de entrada.',
  'auth.sending': 'Enviando...',
  'auth.resendLink': 'Reenviar enlace',
  'auth.phonePlaceholder': 'xxx xx xx xx',

  // Auth - Login
  'auth.signIn': 'Iniciar sesión',
  'auth.signingIn': 'Iniciando sesión...',
  'auth.resetPassword': 'Restablecer contraseña',
  'auth.createAccount': 'Crear cuenta',
  'auth.logIn': 'Iniciar sesión',
  'auth.logInToPurchase': 'Iniciar sesión para comprar',

  // Auth - Account Create
  'auth.zipcodeOptional': 'Código postal (opcional)',
  'auth.zipcodePlaceholder': 'Código postal',
  'auth.phoneNumberOptional': 'Número de teléfono (opcional)',
  'auth.phoneNumber': 'Número de teléfono',
  'auth.birthdayOptional': 'Fecha de nacimiento (opcional)',
  'auth.birthday': 'Fecha de nacimiento',
  'auth.subscribeToMarketing': 'Suscribirse a correos de marketing',
  'auth.create': 'Crear',
  'auth.creating': 'Creando...',
  'auth.alreadyHaveAccount': '¿Ya tienes una cuenta?',

  // Auth - Reset Password
  'auth.submit': 'Enviar',

  // Auth - Errors
  'auth.errorUnableToSignIn': 'No se pudo iniciar sesión. Inténtalo de nuevo.',
  'auth.errorLoginGeneric': 'Se produjo un error al iniciar sesión. Inténtalo de nuevo.',
  'auth.errorRequiredFields': 'Faltan campos obligatorios. Completa el formulario.',
  'auth.errorCreateGeneric': 'Se produjo un error. Inténtalo de nuevo.',
  'auth.errorCreateAccount': 'Se produjo un error al crear la cuenta. Inténtalo de nuevo.',
  'auth.errorEmailNotFound': 'Campo de correo electrónico no encontrado. Inténtalo de nuevo.',
  'auth.errorEnterEmail': 'Ingresa tu dirección de correo electrónico.',
  'auth.errorResetPassword': 'No se pudo restablecer la contraseña. Inténtalo de nuevo.',
  'auth.errorResetGeneric': 'Se produjo un error al restablecer la contraseña. Inténtalo de nuevo.',
  'auth.error.login_required':
    'Se requiere iniciar sesión. Ingresa tu correo electrónico y contraseña.',
  'auth.error.invalid_credentials':
    'Correo electrónico o contraseña no válidos. Inténtalo de nuevo.',
  'auth.error.account_already_exists':
    'Ya existe una cuenta con este correo electrónico. Inicia sesión.',
  'auth.error.invalid_email':
    'La dirección de correo electrónico ingresada no es válida. Inténtalo de nuevo.',
  'auth.error.weak_password': 'Tu contraseña es demasiado débil. Elige una contraseña más segura.',
  'auth.error.missing_fields': 'Todos los campos son obligatorios. Completa el formulario.',
  'auth.error.invalid_name': 'El nombre ingresado no es válido. Usa solo letras.',
  'auth.error.password_mismatch': 'Las contraseñas no coinciden. Inténtalo de nuevo.',
  'auth.error.missing_email': 'Ingresa tu dirección de correo electrónico.',
  'auth.error.email_not_found':
    'No encontramos una cuenta con esta dirección de correo electrónico. Verifícala e inténtalo de nuevo.',
  'auth.error.email_verify': 'Verifica tu dirección de correo electrónico e inténtalo de nuevo.',
  'auth.error.captcha_challenge':
    'Se requiere verificación adicional. Completa el desafío de seguridad.',
  'auth.error.unknown_error': 'Ocurrió un error desconocido. Inténtalo de nuevo más tarde.',

  // Product
  'product.buyNow': 'Comprar ahora',
  'product.soldOut': 'Agotado',
  'product.processing': 'Procesando...',
  'product.errorAddToCart': 'No se pudo agregar al carrito.',

  // Need Access
  'access.logInToWatch': 'Iniciar sesión para ver',
  'access.purchaseAccess': 'Comprar acceso',
  'access.joinOrPurchase': 'Únete a la comunidad o compra acceso',
  'access.noAccess': 'No tienes acceso a este contenido',
  'access.joinToUnlock': 'Únete para desbloquear',
  'access.joinForAccess': 'Únete para acceder',
  'access.locked': 'Bloqueado',
  'access.joinToWatch': 'Únete para ver',
  'access.joinOrPurchaseAccess': 'Únete o compra acceso',
  'access.alreadyPurchased': '¿Ya compraste?',
  'access.logInWithEmail': 'Inicia sesión con el correo electrónico usado para la compra',
  'access.or': '- o -',
  'access.noProductsAvailable': 'Actualmente no hay productos disponibles que otorguen acceso',
  'access.upgradeToAccess': 'Mejora para acceder',

  // Perks
  'perks.posts': 'Publicaciones',
  'perks.videos': 'Videos',
  'perks.merch': 'Merch',
  'perks.codes': 'Códigos',
  'perks.music': 'Música',
  'perks.recentPosts': 'Publicaciones recientes',
  'perks.myAccount': 'Mi cuenta',
  'perks.logout': 'Cerrar sesión',
  'perks.noActiveMemberships': 'Sin membresías activas.',
  'perks.generating': 'Generando...',
  'perks.noCodesFound': 'No se encontraron códigos',
  'perks.noProducts': 'Sin productos',
  'perks.foundFor': 'encontrado para "{query}"',
  'perks.more': 'Más',
  'perks.join': 'Unirse',
  'perks.collectibles': 'Coleccionables',
  'perks.popularPosts': 'Publicaciones populares',
  'perks.noPosts': 'Sin publicaciones',
  'perks.adjustFilters': '¡Intenta ajustar tus filtros o vuelve pronto!',
  'perks.loadMorePosts': 'Cargar más publicaciones',
  'perks.loadMore': 'Cargar más',
  'perks.memberSince': 'Miembro desde',
  'perks.continueReading': 'Continuar leyendo',
  'perks.joinToContinueReading': 'Únete para continuar leyendo',
  'perks.beFirstToComment': '¡Sé el primero en dejar un comentario!',
  'perks.addComment': 'Agregar un comentario...',
  'perks.addCommentButton': 'Agregar un comentario',
  'perks.joinToComment': 'Únete para comentar',
  'perks.commentRemoved': '[ eliminado ]',
  'perks.commentHasBeenRemoved': 'El comentario ha sido eliminado.',
  'perks.reply': 'Responder',
  'perks.replyToComment': 'Responder al comentario...',
  'perks.viewReplies': 'Ver respuestas',
  'perks.loadMoreReplies': 'Cargar más respuestas',
  'perks.replyCount.one': '1 respuesta',
  'perks.replyCount.other': '{count} respuestas',
  'perks.filterPosts': 'Filtrar publicaciones',
  'perks.postType': 'Tipo de publicación',
  'perks.postTypeText': 'Texto',
  'perks.postTypeImages': 'Imágenes',
  'perks.postTypeVideos': 'Videos',
  'perks.postTypeProducts': 'Productos',
  'perks.postTypeAudio': 'Audio',
  'a11y.play': 'Reproducir',
  'a11y.pause': 'Pausa',
  'a11y.seek': 'Progreso',
  'a11y.audioArtwork': 'Portada de audio',
  'a11y.trackArtwork': 'Portada de {title}',
  'a11y.viewArtwork': 'Ver portada',
  'perks.tags': 'Etiquetas',
  'perks.authors': 'Autores',
  'perks.submission.submitPost': 'Enviar una publicación',
  'perks.submission.createPost': 'Crear una publicación',
  'perks.submission.postingAs': 'Publicando como',
  'perks.submission.loginRequired': 'Inicia sesión en tu cuenta para compartir una publicación.',
  'perks.submission.titleLabel': 'Título',
  'perks.submission.titlePlaceholder': 'Dale un título a tu publicación',
  'perks.submission.captionLabel': 'Descripción',
  'perks.submission.captionPlaceholder': 'Agrega una descripción',
  'perks.submission.addImage': 'Agregar una foto',
  'perks.submission.changeImage': 'Cambiar foto',
  'perks.submission.uploading': 'Subiendo...',
  'perks.submission.submit': 'Enviar para revisión',
  'perks.submission.submitting': 'Enviando...',
  'perks.submission.post': 'Publicar',
  'perks.submission.posting': 'Publicando...',
  'perks.submission.postAnother': 'Publicar otra',
  'perks.submission.success': '¡Enviado! Tu publicación está pendiente de revisión.',
  'perks.submission.successPublished': 'Tu publicación ya está publicada.',
  'perks.submission.submitAnother': 'Enviar otra',
  'perks.submission.invalidImageType': 'Elige una imagen JPG, PNG o GIF.',
  'perks.submission.invalidImageSize': 'Las imágenes deben ser menores de 25 MB.',
  'perks.submission.errorUploadImage': 'Algo salió mal al subir tu imagen. Inténtalo de nuevo.',
  'perks.submission.errorSubmit': 'Algo salió mal al enviar tu publicación. Inténtalo de nuevo.',
  'perks.submission.errorLimit': 'Límite de envíos alcanzado. Inténtalo de nuevo mañana.',
  'perks.submission.errorUsername': 'El nombre de usuario no está disponible para envíos',
  'perks.submission.removeImage': 'Quitar foto',
  'perks.badge.artist': 'Verificado',
  'perks.badge.team': 'Equipo',
  'perks.shadowBanned': 'Baneo en la sombra: solo este fan y los moderadores pueden verlo. Levántalo en tu panel de Single, en Posts > Configuración.',
  'perks.artistProfileManaged': 'Tu perfil de artista se gestiona en el panel de Single',
  'perks.clearAll': 'Borrar todo',
  'perks.applyFilters': 'Aplicar filtros',
  'perks.backToFeed': '← Volver al feed',
  'perks.backToLibrary': '← Volver a la biblioteca',
  'music.album': 'Álbum',
  'music.download': 'Descargar',
  'music.loginToDownload': 'Iniciar sesión para descargar',
  'music.linkExpired': 'Este enlace ha caducado.',
  'music.loginToAccess':
    'Inicia sesión con el correo electrónico proporcionado durante la compra para escuchar o descargar.',
  'perks.noVideos': 'Sin videos',
  'perks.noMusic': 'Sin música',
  'perks.gridView': 'Vista de cuadrícula',
  'perks.listView': 'Vista de lista',
  'perks.oops': '¡Ups!',
  'perks.notFound': '404: Not Found',
  'perks.goBack': 'Volver',
  'perks.account': 'Cuenta',
  'perks.displayName': 'Nombre de pantalla',
  'perks.emailPreferences': 'Preferencias de correo electrónico',
  'perks.emailPreference.POST_NOTIFICATIONS': 'Nuevas publicaciones',
  'perks.emailPreference.POST_NOTIFICATIONS.description':
    'Recibe un correo electrónico cuando se publique una nueva publicación.',
  'perks.emailPreference.COMMENT_NOTIFICATIONS': 'Comentarios y respuestas',
  'perks.emailPreference.COMMENT_NOTIFICATIONS.description':
    'Recibe un correo electrónico cuando alguien responda a tu comentario.',
  'perks.emailPreference.COMMENT_NOTIFICATIONS.description.submissions':
    'Recibe un correo electrónico cuando alguien responda a tu comentario o comente una publicación que enviaste.',
  'perks.emailPreference.COMMENT_NOTIFICATIONS.description.author':
    'Recibe un correo electrónico cuando alguien responda a tu comentario o comente una publicación que publicaste.',
  'perks.comments': 'Comentarios',
  'perks.view': 'Ver',
  'perks.transfer': 'Transferir',
  'perks.logInToViewCollectibles': 'Iniciar sesión para ver coleccionables',
  'perks.viewAll': 'Ver todo',
  'perks.errorUploadAvatar': 'No se pudo subir el avatar. Inténtalo de nuevo.',
  'perks.profileCardTitle': '¡Bienvenido! Completemos tu perfil de miembro.',
  'perks.walletCardTitle': 'Descarga tu tarjeta de membresía',
  'perks.walletPassDescription':
    'Tu pase de miembro es una tarjeta de club digital para tu dispositivo Apple o Android. Se utilizará para otorgarte ventajas especiales en shows y en persona.',
  'perks.walletScanDescription': 'Escanea el código QR con tu teléfono para descargar tu pase.',
  'perks.updatingProfile': 'Actualizando...',
  'perks.updateProfile': 'Actualizar perfil',
  'perks.displayNamePlaceholder': 'Escribe tu nombre aquí...',
  'perks.usernamePlaceholder': 'Nombre de usuario',
  'perks.profileVisibilityNote':
    'Solo tu avatar y tu nombre de pantalla serán visibles para otros miembros.',
  'perks.trackCount': '{count} pistas',
  'perks.trackCountOne': '{count} pista',
  'perks.commentCount': '{count} comentarios',
  'perks.commentCountOne': '{count} comentario',
  'perks.replyingTo': 'Respondiendo a @{name}',
  'perks.postCommentButton': 'Publicar',
  'perks.avatarAlt': 'Avatar de {name}',
  'perks.hiddenPostImageAlt': 'Imagen de publicación oculta',
  'perks.postImageAlt': 'Imagen de la publicación',
  'perks.imageSlideAlt': 'Diapositiva de imagen',
  'perks.videoThumbnailAlt': 'Miniatura del video',
  'perks.productImageAlt': 'Producto',
  'perks.membershipImageAlt': 'imagen de la membresía',
  'perks.tierImageAlt': 'imagen del nivel',
  'perks.authorImageAlt': 'imagen del autor',
  'perks.submission.previewAlt': 'vista previa del envío',
  'a11y.countryCode': 'Código de país',
  'a11y.dismiss': 'Descartar',

  // Address Modal
  'address.updateAddress': 'Actualizar dirección',
  'address.firstName': 'Nombre',
  'address.lastName': 'Apellido',
  'address.street': 'Calle',
  'address.streetLine2': 'Calle (línea 2)',
  'address.city': 'Ciudad',
  'address.country': 'País',
  'address.province': 'Provincia',
  'address.zip': 'Código postal',
  'address.phoneNumber': 'Número de teléfono',
  'address.update': 'Actualizar',
  'address.updating': 'Actualizando...',
  'address.errorStreetRequired': 'La dirección es obligatoria',
  'address.errorCountryRequired': 'El país es obligatorio',
  'address.errorZipRequired': 'El código postal es obligatorio',
  'address.errorPhoneRequired': 'El número de teléfono es obligatorio',

  // Common
  'common.cancel': 'Cancelar',
  'common.ok': 'Aceptar',
  'common.close': 'Cerrar',
  'common.dialog': 'Diálogo',
  'a11y.communityNav': 'Páginas de la comunidad',
  'a11y.likePost': 'Me gusta la publicación',
  'a11y.unlikePost': 'Quitar me gusta de la publicación',
  'a11y.viewComments': 'Ver comentarios',
  'a11y.previousSlide': 'Diapositiva anterior',
  'a11y.nextSlide': 'Siguiente diapositiva',
  'a11y.goToSlide': 'Ir a la diapositiva {number}',
  'a11y.collapseComment': 'Contraer comentario',
  'a11y.expandComment': 'Expandir comentario',
  'a11y.commentMenu': 'Opciones del comentario',
  'a11y.deleteComment': 'Eliminar comentario',
  'a11y.likeComment': 'Me gusta el comentario',
  'a11y.unlikeComment': 'Quitar me gusta del comentario',
  'a11y.reply': 'Responder',
  'a11y.closeReplies': 'Cerrar respuestas',
  'a11y.backToFeed': 'Volver al feed',
  'a11y.uploadAvatar': 'Subir avatar',
  'common.searchByTitle': 'Buscar por título',
  'common.search': 'Buscar',
  'common.clear': 'Borrar',
  'common.error': 'Error',
  'common.save': 'Guardar',
  'common.saving': 'Guardando...',
  'common.edit': 'Editar',
  'common.delete': 'Eliminar',
  'common.loading': 'Cargando...',
  'common.uploading': 'Subiendo...',
  'common.readMore': 'leer más',
  'common.readLess': 'leer menos',
  'common.share': 'Compartir',
  'common.copied': '¡Copiado!',
  'common.browserShareError': 'Tu navegador no admite funciones de compartir o portapapeles.',
  'common.alreadyMember': '¿Ya eres miembro?',

  // Membership
  'membership.confirm': 'Confirmar',
  'membership.nevermind': 'No importa',
  'membership.noGoBack': 'No, Volver',
  'membership.yesCancel': 'Sí, Cancelar',
  'membership.goBack': 'Volver',
  'membership.continue': 'Continuar',
  'membership.confirmChange': 'Confirmar cambio',
  'membership.termsAndConditions': 'Términos y condiciones',
  'membership.updateBillingTerms': 'Actualizar tus términos de facturación',
  'membership.confirmYourChanges': 'Confirma tus cambios',
  'membership.confirmUpgrade': 'Confirmar actualización',
  'membership.confirmDowngrade': 'Confirmar cambio a plan inferior',
  'membership.termChange': 'Cambio de término',
  'membership.labelCancellation': 'Cancelación {label}',
  'membership.cancelPendingTitle': 'Cancelar {change}',
  'membership.yesCancelPending': 'Sí, cancelar {change}',
  'membership.revertSettings': 'Tu {label} volverá a su configuración anterior.',
  'membership.cancelTitle': 'Cancelar {label}',
  'membership.areYouSureCancel': '¿Estás seguro de que deseas cancelar?',
  'membership.cancellationEndOfTerm': 'Tu cancelación entrará en vigor al final de tu período.',
  'membership.stillHaveAccess':
    'Sin embargo, todavía tendrás acceso a tu {label} de pago por el resto de tu período.',
  'membership.expirationDate': 'Fecha de vencimiento de {label}:',
  'membership.notice': 'Aviso:',
  'membership.cancellationNotice':
    'Las cancelaciones de {label} no entrarán en vigor hasta el final de tu período.',
  'membership.contactForQuestions': 'Para preguntas sobre la cancelación de tu {label}, contacta',
  'membership.contactIfUnsure':
    'Si no estás seguro de si esto se aplica a tu pedido específico, contacta al servicio al cliente.',
  'membership.cancelMembershipButton': 'Cancelar membresía',
  'membership.currentPlan': 'Plan actual',
  'membership.newPlan': 'Nuevo plan',
  'membership.newPlanStarts': 'Tu nuevo plan comienza el',
  'membership.newTierTerm': 'Nuevo término de nivel:',
  'membership.nextBillingDateLabel': 'Próxima fecha de facturación:',
  'membership.perMonth': '/Mes',
  'membership.aboutToUpgrade': 'Estás a punto de actualizar tu nivel de membresía.',
  'membership.aboutToDowngrade': 'Estás a punto de cambiar a un nivel inferior de membresía.',
  'membership.viewMyPerks': 'Ver mis beneficios',
  'membership.manage': 'Gestionar',
  'membership.joining': 'Uniéndose...',
  'membership.join': 'Unirse',
  'membership.addingToCart': 'Agregando al carrito...',
  'membership.upgrade': 'Actualizar',
  'membership.downgrade': 'Cambiar a plan inferior',
  'membership.cancelPendingChanges': 'Cancelar cambios pendientes',
  'membership.active': 'Activo',
  'membership.nextBillingDate': 'Próxima facturación',
  'membership.term': 'Período',
  'membership.changeTerm': '(cambiar)',
  'membership.price': 'Precio',
  'membership.free': 'GRATIS',
  'membership.per': 'por',
  'membership.oneTimePurchase': 'Compra única',
  'membership.noMembershipsAvailable': 'Sin membresías disponibles',
  'membership.transactionFailed': 'Transacción {label} fallida - Haz clic para actualizar',
  'membership.noActiveMemberships': 'Sin membresías activas',
  'membership.pending': 'Pendiente',
  'membership.cancellation': 'Cancelación',
  'membership.upgradeDowngrade': 'Actualizar / Bajar de plan',
  'membership.cancelLink': 'Cancelar',
  'membership.nextShipment': 'Próximo envío •',
  'membership.viewProduct': 'Ver producto',
  'membership.hasBeenScheduled': 'ha sido programado.',
  'membership.changingTo': 'Cambiando a:',
  'membership.willBeDowngradedTo': 'Tu {label} será degradado a',
  'membership.on': 'el',
  'membership.stillHaveAccessUntil': 'Todavía tendrás acceso hasta el',
  'membership.cancelChange': 'Cancelar cambio',
  'membership.nextBilling': 'Próxima facturación',
  'membership.subscriptionShipMonthly': 'Los pedidos de suscripción se envían mensualmente.',
  'membership.noUpcomingBillDates': 'Sin fechas de facturación próximas.',
  'membership.orderHistory': 'Historial de pedidos',
  'membership.emailWithTracking':
    'Recibirás un correo electrónico con seguimiento una vez que tu pedido haya sido enviado.',
  'membership.back': '← Volver',
  'membership.shippingAddress': 'Dirección de envío',
  'membership.missingAddress': 'Información de dirección faltante. Haz clic para actualizar.',
  'membership.editShippingAddress': 'Editar dirección de envío',
  'membership.paymentMethod': 'Método de pago',
  'membership.updatePaymentInstructions':
    'Para actualizar tu método de pago, usa el enlace a continuación. Se te enviará un correo electrónico con instrucciones.',
  'membership.updatePaymentMethod': 'Actualizar método de pago',
  'membership.paymentFailed': 'Pago fallido',
  'membership.productImageAlt': 'imagen del producto',
  'membership.detailMembership': 'Membresía',
  'membership.detailBilling': 'Facturación',
  'membership.detailPlan': 'Plan',
  'membership.detailMemberId': 'ID de miembro',
  'membership.detailSubscriptionNumber': 'N.º de suscripción',
  'membership.detailStatus': 'Estado',
  'membership.detailTerms': 'Condiciones',
  'membership.detailLastPayment': 'Último pago',
  'membership.receivedOn': 'Recibido el {date}',
  'membership.receivedAmountOn': '{amount} recibido el {date}',
  'membership.detailName': 'Nombre',
  'membership.detailStreet': 'Calle',
  'membership.detailCity': 'Ciudad',
  'membership.detailState': 'Estado/Provincia',
  'membership.detailZip': 'Código postal',
  'membership.detailCountry': 'País',
  'membership.detailPhone': 'Teléfono',
  'membership.detailCard': 'Tarjeta',
  'membership.detailNumber': 'Número',
  'membership.detailExpires': 'Vence',
  'membership.detailMethod': 'Método',
  'membership.manageLabel': 'Gestionar {label}',

  // Music
  'music.exclusive': 'Exclusivo',
  'music.trackTitle': 'Título',
  'music.songCount': '{count} canciones',
  'music.songCountOne': '{count} canción',
  'music.allTracksAvailableIn': 'TODAS LAS CANCIONES DISPONIBLES EN:',
  'music.preorderUnlock':
    'Reserva ahora y desbloquea el acceso para escuchar o descargar el {date}.',
  'music.downloadUnavailable': 'Descarga no disponible',
  'music.downloadLimitReached': 'Has alcanzado el límite de descargas. Contacta con la tienda.',
  'music.downloadFailed': 'La descarga falló. Inténtalo de nuevo.',
  'music.downloadNotAllowed': 'Inicia sesión con el correo que usaste para la compra.',
  'music.downloadCodeUnavailable': 'Esta descarga no está disponible. Contacta con la tienda.',
  'music.downloadStarted': 'Descarga iniciada',
  'music.downloadStartedHint': 'Revisa tus descargas o la app Archivos.',
  'music.openInBrowserTitle': 'Descarga bloqueada',
  'music.openInBrowserBody':
    'El navegador integrado que estás usando bloquea las descargas. Tendrás que abrir esta página en un navegador externo.',
  'music.openInBrowserHint':
    'Toca el icono ••• y selecciona «Abrir en navegador externo» para continuar.',
  'music.demoArtist': 'Artista de prueba',
  'music.demoAlbum': 'Álbum de demostración',
  'music.demoTrack': 'Pista {n}',
  'a11y.previousTrack': 'Pista anterior',
  'a11y.nextTrack': 'Siguiente pista',
  'a11y.playAll': 'Reproducir todo',

  // Video
  'video.startsIn': 'Comienza en:',
  'video.previewTitle': 'Título del video',
  'video.previewArtist': 'Nombre del artista',
  'video.previewDescription': 'Descripción del video',
};
